var bts = angular.module("bootstrap.unified", []);
//bootstrap.value("portal", "member");
bts.run(["link", "navigation", "brand", "sessionData", "modal", "hook", "$cookies", function (link, navigation, brand, sessionData, modal, hook, $cookies) {

    hook.register('clientPortalSessionStart', ["$cookies", "teamsite", "brand", "coremetrics", "services", "$q", "sessionData", "brandConfig", "$interval", "session", "appConfig", "$state", function($cookies, teamsite, brand, coremetrics, services, $q, sessionData, brandConfig, $interval, session, appConfig, $state) {

        if(!sessionData.adminMode){
            if(window.location.href.match(/.+\/admin/g)){
                sessionData.adminMode = true;
            }else{
                sessionData.adminMode = false;
            }
        }

        if(!sessionData.imageSrc){
            services.clxptl.avatar().getUserAvatar().then(function(response){
                if(response.data){
                    sessionData.imageSrc = '/clxptl/x-services/secure/user/avatar';
                }
            },function(error){
                sessionData.imageSrc = "bootstrap/v4/resources/img/hmhs/defaultAvatar.png";
            });
        }

        if(!sessionData.userInfo || !sessionData.userEntitlements){
            return services.clxptl.login().loginCache().then(function(response){
                sessionData.userInformation = response.data.payload.userInfo;
                sessionData.userEntitlements = response.data.payload.userAccess;
                navigation.update();
            });
        }


    }]);
}]);
